import { Dialog, Divider, Grid, makeStyles } from "@material-ui/core";
import React, { useRef, useState } from "react";
import DialogHeader from "../DialogHeader";
import {
  Container,
  TextField,
  Typography,
  Button,
  Box,
} from "@material-ui/core";
import { DESTROY_BACKDROP, OPEN_BACKDROP } from "../../../../containers/actions/types";
import { useDispatch } from "react-redux";
import StyledDialog from "../../../../../common/models/Dialog";
import BackDropLoading from "../../../common/models/BackDrop";

const useStyles = makeStyles((theme) => ({
  list: {
    width: "40vw",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("xs")]: {
      width: "80vw",
    },
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "90px",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "space-between",
    position: "absolute", // Keeps buttons in place
    bottom: "20px", // Positions it near bottom
    width: "90%",
    left: "5%",
  },
  requiredLabel: {
    color: "red",
  },
  textField: {
    width: "100%",
  },
  header: {
    fontWeight: "500",
    marginBottom: "8px",
  },
  container: {
    padding: "1rem",
  },
  textArea: {
    width: "100%",
    minHeight: "60px",
  },
}));

const EditWarehouseDetails = (props) => {
  const  { warehouseDetails, handleClose , handleRefresh, closeView}  = props;
  const classes = useStyles();

  const [formData, setFormData] = useState(warehouseDetails);

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false); // State to manage Backdrop
 const dispatch = useDispatch();
  // const errorRef = useRef();
   
const [touched, setTouched] = useState(false);  // Track if Save Changes was clicked
const [savedSuccessfull, setSavedSuccessfull] = useState(false);



  // Validation function
  const requiredFields = ["warehouseMainAddress", "warehouseCode", "pickupAddress", "deliveryAddress"];

  // Validate function
  const validateForm = () => {
    let newErrors = {};
    
    requiredFields.forEach((field) => {
      if (!formData[field] || formData[field].trim() === "") {
        newErrors[field] = "Required field";
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // If the form has been touched, validate the individual field
    if (touched) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: value.trim() !== "" ? "" : "Required field",
      }));
    }
  };

  // Handle blur to trim leading and trailing spaces
  const handleBlur = (e) => {
    const { name, value } = e.target;
    // Only trim leading and trailing spaces for string values
    if (typeof value === "string" && value.trim() !== value) {
      const trimmedValue = value.trim();
      setFormData({ ...formData, [name]: trimmedValue });
    }
  };

  //Handle Save Changes button click
  const handleSave = () => {
    const validated = validateForm();
    setTouched(true); // Mark the form as touched
    
    // if (validateForm()) {
    //   // console.log("Form submitted successfully:", formData);
    //   // Proceed to the next step (e.g., API call or navigation)
    // }
    
        
        if (validated) {
          dispatch({
            type: OPEN_BACKDROP,
            backdropText: 'Please wait...',
          });
          setTimeout(() => {
            dispatch({
              type: DESTROY_BACKDROP,
            });
            // setmainError('Something went wrong. Please try again.')
            // errorRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
            setSavedSuccessfull(true);
          },3000)
        }
        //  else {
        //   setErrors('Enter the mandatory fields')
        //     errorRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        // }
  };

const handleCloseSave = () => {
    setSavedSuccessfull(false);
    handleClose()
    closeView()
    handleRefresh()
    
  }
  

  const handleCancel = () => {
    handleClose();  // Close the drawer and go back to `ViewEditWarehouse`
  };

  return (
    
    <React.Fragment>
      <BackDropLoading />
      <div className={classes.list}>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          style={{ padding: "1rem" }}
        >
          <Grid item xs={12}>
            <DialogHeader header={"Edit warehouse details"} />
          </Grid>
          <Container maxWidth="sm" >
        <Typography variant="h6" className={classes.header}>
          {formData.warehouseName}
        </Typography>

            <Grid container spacing={2} style={{ marginTop: "1rem" }}>
              <Grid item xs={12}>
                <Typography className={classes.header}>Warehouse ID</Typography>
                <TextField
                  name="warehouseCode"
                  value={formData.warehouseCode}
                  fullWidth
                  variant="outlined"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  size="small"
                  //disabled
                  multiline
                  className={classes.textField}
                  placeholder="Enter the unique warehouse ID"
                  error={Boolean(errors.warehouseCode)}
                  helperText={errors.warehouseCode}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography className={classes.header}>
                  Main address <span className={classes.requiredLabel}>*</span>
                </Typography>
                <TextField
                  name="warehouseMainAddress"
                  value={formData.warehouseMainAddress}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  fullWidth
                  variant="outlined"
                  size="small"
                  multiline
                  rows={3}
                  className={classes.textArea}
                  placeholder="Enter the Main address"
                  error={Boolean(errors.warehouseMainAddress)}
                  helperText={errors.warehouseMainAddress}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography className={classes.header}>
                  Pickup address
                </Typography>
                <TextField
                  name="pickupAddress"
                  value={formData.pickupAddress}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  fullWidth
                  variant="outlined"
                  size="small"
                  multiline
                  rows={3}
                  className={classes.textArea}
                  placeholder="Enter the Pickup address"
                  error={Boolean(errors.pickupAddress)}
                  helperText={errors.pickupAddress}
                />
              </Grid>
              <Grid item xs={12} className={classes.bottomSpacing}>
                <Typography className={classes.header}>
                  Delivery address
                </Typography>
                <TextField
                  name="deliveryAddress"
                  value={formData.deliveryAddress}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  fullWidth
                  variant="outlined"
                  size="small"
                  multiline
                  rows={3}
                  className={classes.textArea}
                  placeholder="Enter the Delivery address"
                  error={Boolean(errors.deliveryAddress)}
                  helperText={errors.deliveryAddress}
                />
              </Grid>
            </Grid>
            <Box className={classes.buttonContainer}>
              <Button
                variant="contained"
                color="default"
                size="small"
                onClick={handleCancel}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                size="small"
                style={{ backgroundColor: "#173072", color: "white" }}
                onClick={handleSave}
              >
                Save changes
              </Button>
            </Box>
          </Container>
        </Grid>
      </div>

      <Dialog open={savedSuccessfull} fullWidth>
                    <StyledDialog
                      icons={true}
                      handleClose={handleCloseSave}
                      title={'Warehouse Details saved successfully'}
                    />
                  </Dialog>

     
    </React.Fragment>
  );
};

export default EditWarehouseDetails;
